// import { apiSlice } from "../../app/api/apiSlice";

import { apiSlice } from "../../api/apiSlice";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: "/api/auth/admin-login",
        method: "POST",
        body: { ...credentials },
      }),
    }),
    forgotPassword: builder.mutation({
      query: (data) => ({
        url: "/api/auth/admin-forgot-password",
        method: "POST",
        body: { ...data },
      }),
    }),
    resetPassword: builder.mutation({
      query: ({ token, ...data }) => ({
        url: `/api/auth/admin-reset-password/${token}`,
        method: "POST",
        body: { ...data },
      }),
    }),
    logout: builder.mutation({
      query: () => ({
        url: "/api/admin/auth/logout",
        method: "DELETE",
      }),
    }),
    changePassword: builder.mutation({
      query: (body) => ({
        url: "/api/auth/admin-change-password",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useChangePasswordMutation,
} = authApiSlice;
